import api from "./Api";

class PedidoReceberService {
  GetPedidoReceber(payload) {
    return api.get("/v1/pedidoReceber/" + payload).then((response) => {
      return response.data;
    });
  }

  PostPedidoReceber(payload) {
    return api.post("/v1/pedidoReceber/", payload).then((response) => {
      return response.data;
    });
  }

  PutPedidoReceber(payload) {
    return api.put("/v1/pedidoReceber/", payload).then((response) => {
      return response.data;
    });
  }

  DeletePedidoReceber(payload) {
    return api.delete("/v1/pedidoReceber/" + payload).then((response) => {
      return response.data;
    });
  }

  GetPedidoReceberOData(payload) {
    return api.get("/OData/PedidoReceber" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new PedidoReceberService();
